module.exports = __webpack_public_path__ + "img/tab3-1@2x.187674dd.png";